import template from './notfound.html';
import controller from './notfound.controller';

let notfoundComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default notfoundComponent;



// WEBPACK FOOTER //
// ./client/pages/404/notfound.component.js